import type { DraftStoreType } from '../../../state/reducers/draft/draft'

const draftKey = 'draft'

export const saveDraft = (draft: DraftStoreType) => {
  try {
    const serializedDraft = JSON.stringify(draft)
    return localStorage.setItem(draftKey, serializedDraft)
  } catch (err) {
    return undefined
  }
}

export const loadDraft = (): DraftStoreType | undefined => {
  try {
    const serializedState = localStorage.getItem(draftKey)
    if (!serializedState) {
      return undefined
    }
    const draft = JSON.parse(serializedState)
    draft.draft.publicationPeriod.start = new Date(draft.draft.publicationPeriod.start)
    draft.draft.publicationPeriod.end = new Date(draft.draft.publicationPeriod.end)
    return draft
  } catch (err) {
    return undefined
  }
}

export const removeDraft = () => {
  try {
    return localStorage.removeItem(draftKey)
  } catch (err) {
    return undefined
  }
}
